// Module-level registry for the configure-devices flow's completion callback.
// The callback survives navigation between routes (the JS module persists for
// the SPA session) but is consumed exactly once at end-of-flow so it does not
// leak into a later, unrelated invocation.
let pendingOnComplete: (() => void) | null = null

export function setPendingOnComplete(callback: (() => void) | undefined) {
  pendingOnComplete = callback ?? null
}

export function consumePendingOnComplete(): (() => void) | null {
  const callback = pendingOnComplete
  pendingOnComplete = null
  return callback
}

export function clearPendingOnComplete() {
  pendingOnComplete = null
}
